import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'

import {
  Button,
  Card,
  CardContent,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import FamilyRecord from './family'
import SpiritualRecord from './spiritual'
import SocialRecord from './social'
import AcademicRecord from './academic'
import ExtraRecord from './extra'
import VirtuesRecord from './virtues'
import HobbiesRecord from './hobbies'

const StudentRecord = (props) => {

  const navigate = useNavigate()

  const [section, setSection] = useState('family')

  const items = [
    { id: 'family', primary: 'Familia', secondary: '', details: <FamilyRecord /> },
    { id: 'spiritual', primary: 'Espiritual', secondary: '', details: <SpiritualRecord /> },
    { id: 'social', primary: 'Social', secondary: '', details: <SocialRecord /> },
    { id: 'academic', primary: 'Académico', secondary: '', details: <AcademicRecord /> },
    { id: 'extra', primary: 'Extracurricular', secondary: '' },
    { id: 'virtues', primary: 'Virtudes', secondary: '' },
    { id: 'hobbies', primary: 'Hobbies', secondary: '' },
  ]

  const ListItemCard = (props) => {
    const { item } = props
    const { id, primary } = item

    return (
      <ListItemButton key={`section_${id}`} onClick={() => setSection(id)} sx={{ bgcolor: section === id ? '#655dc611' : 'transparent', borderColor: section === id ? '#4d4084' : '#eaeaea', borderRadius: 2, borderStyle: 'solid', borderWidth: section === id ? 2 : 1, mt: 2 }}>
        <ListItemText primary={<span style={{ color: section === id ? '#4d4084' : '#9a9a9a', fontWeight: section === id ? 900 : 400 }}>{primary}</span>} />
      </ListItemButton>
    )
  }

  // const AccordionCard = (props) => {
  //   const { item } = props
  //   const { id, primary, secondary, details } = item

  //   return (
  //     <Accordion variant='contained' key={`section_${id}`}>
  //       <AccordionSummary
  //         expandIcon={<ExpandMoreIcon />}
  //       >
  //         <Typography>{<b>{primary}</b>}</Typography>
  //       </AccordionSummary>
  //       <AccordionDetails>
  //         { details }
  //       </AccordionDetails>
  //     </Accordion>
  //   )
  // }

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Button onClick={() => navigate(-1)} size='large' startIcon={<ArrowBackIcon />}>
          <b>Volver</b>
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography color='primary' variant='h5'>
          <b style={{ fontWeight: 900 }}>EXPEDIENTE PERSONAL</b>
        </Typography>
      </Grid>
      {/* <Grid item xs={12}>
      {
        items.map((item, index) => (
          <AccordionCard item={item} />
        ))
      }
      </Grid> */}
      <Grid item xs={3}>
        <Card sx={{ borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>SECCIONES</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <List disablePadding>
                  {
                    items.map((item, index) => (
                      <ListItemCard item={item} />
                    ))
                  }
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid hidden={section !== 'family'} item xs={9}>
        <FamilyRecord />
      </Grid>
      <Grid hidden={section !== 'spiritual'} item xs={9}>
        <SpiritualRecord />
      </Grid>
      <Grid hidden={section !== 'social'} item xs={9}>
        <SocialRecord />
      </Grid>
      <Grid hidden={section !== 'academic'} item xs={9}>
        <AcademicRecord />
      </Grid>
      <Grid hidden={section !== 'extra'} item xs={9}>
        <ExtraRecord />
      </Grid>
      <Grid hidden={section !== 'virtues'} item xs={9}>
        <VirtuesRecord />
      </Grid>
      <Grid hidden={section !== 'hobbies'} item xs={9}>
        <HobbiesRecord />
      </Grid>
    </Grid>
  )
}

export default StudentRecord